import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";
import { MEDIATORS_URL } from "@/entities/mediation/lib/utils";
import { MediationStatus } from "@/entities/mediation/model/types";

export const mediationLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw redirect("/auth", { status: 301 });
  }

  const cabinetInformation = await queryClient.fetchQuery(
    getCabinetQueryOptions(token),
  );

  const mediationData = cabinetInformation?.data?.agreement?.mediation;

  if (!mediationData) {
    throw redirect("/cabinet", { status: 301 });
  }

  const mediationUrlParams = mediationData?.redirect_url;
  const mediationPending =
    cabinetInformation?.data?.agreement?.mediation?.status ===
    MediationStatus.Pending;
  const mediationActive =
    cabinetInformation?.data?.agreement?.mediation?.status ===
    MediationStatus.Active;

  if ((mediationPending || mediationActive) && !!mediationUrlParams) {
    throw redirect(`${MEDIATORS_URL}/cabinet${mediationUrlParams}`);
  }

  return mediationData;
};
